import { QueryParamConfig, QueryParamOptions, UrlUpdateType, useQueryParam } from "use-query-params"

declare type NewValueType<D> = D | ((latestValue: D) => D)

export const useQueryParamWrapper = <TypeToEncode, TypeFromDecode = TypeToEncode>(
  name: string,
  paramConfig?: QueryParamConfig<TypeToEncode, TypeFromDecode> | undefined,
  options?: QueryParamOptions,
): [TypeFromDecode, (newValue: NewValueType<TypeToEncode>, updateType?: UrlUpdateType) => void] => {
  return useQueryParam(name, paramConfig, {
    updateType: "replaceIn",
    ...options,
  })
}
